import React from 'react'
import { Spinner } from './styled'

const Loader: React.FC = () => {
  return <Spinner />
}

export default Loader
